<template>
  <v-row no-gutters class="pt-5">
    <v-col class="pr-2">
      <card-title-row translation-path="sidebar.calibrationFilesGeneration.title" :has-buttons="false">
        <template #subtitle>
          <italic-subheader translation-path="sidebar.calibrationFilesGeneration.subtitle" style="text-align: left" />
        </template>
      </card-title-row>
      <v-form ref="calibrationFileForm" v-model="isFormValid">
        <sidebar-row class="pt-10">
          <v-row no-gutters align="baseline">
            <v-col cols="4" class="text-body-2 text-left pr-4 align-self-stretch">
              {{ $i18n.t('sidebar.calibrationFilesGeneration.timeInterval') }}:
            </v-col>
            <v-col cols="1">
              <v-icon class="pr-1" color="rgba(0,0,0,0.7)">mdi-calendar</v-icon>
            </v-col>
            <v-col cols="7">
              <data-input
                v-model="timeInterval"
                :data-type="{ name: 'daterange' }"
                locale-date-format="YYYY-MM-DD"
                return-type="date"
                v-bind="{
                  rules: [v => !!v || $i18n.t('rules.required')],
                }"
              />
            </v-col>
          </v-row>
        </sidebar-row>
        <sidebar-row class="pt-4">
          <v-row no-gutters class="justify-space-between">
            <v-col cols="4" class="text-body-2 center-content text-left">
              {{ $i18n.t('sidebar.calibrationFilesGeneration.calculationsMethod') }}:
            </v-col>
            <v-col cols="7">
              <v-radio-group v-model="calculationsMethod" class="center-content" hide-details mandatory>
                <v-radio value="exact">
                  <template #label>
                    <div class="text-body-2 text-left label-dark">
                      {{ $i18n.t('sidebar.calibrationFilesGeneration.fullIntervalData') }}
                    </div>
                  </template>
                </v-radio>
                <v-radio value="average">
                  <template #label>
                    <div class="text-body-2 text-left label-dark">
                      {{ $i18n.t('sidebar.calibrationFilesGeneration.averageForInterval') }}
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </sidebar-row>
        <sidebar-row class="pt-7">
          <v-row no-gutters class="justify-space-between">
            <v-col cols="4" class="text-body-2 text-left center-content">
              {{ $i18n.t('sidebar.calibrationFilesGeneration.noDataFilterMethod') }}:
            </v-col>
            <v-col cols="7">
              <v-radio-group v-model="filterMethod" class="center-content" hide-details mandatory>
                <v-radio value="skip">
                  <template #label>
                    <div class="text-body-2 text-left label-dark">
                      {{ $i18n.t('sidebar.calibrationFilesGeneration.skipSeries') }}
                    </div>
                  </template>
                </v-radio>
                <v-radio value="error">
                  <template #label>
                    <div class="text-body-2 text-left label-dark">
                      {{ $i18n.t('sidebar.calibrationFilesGeneration.showErrorMessage') }}
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </sidebar-row>
        <sidebar-row class="pt-7">
          <v-checkbox v-model="averageData">
            <template #label>
              <div class="text-body-2 text-left label-dark">
                {{ $i18n.t('sidebar.calibrationFilesGeneration.averageData') }}
              </div>
            </template>
          </v-checkbox>
        </sidebar-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import SidebarRow from '@/components/SidebarRow';
import CardTitleRow from '@/components/CardTitleRow';
import ItalicSubheader from '@/components/ItalicSubheader';
import DataInput from '@/components/DataInput';

import { sync, call } from 'vuex-pathify';

export default {
  name: 'CalibrationFilesGeneration',
  components: {
    CardTitleRow,
    ItalicSubheader,
    SidebarRow,
    DataInput,
  },
  data: () => ({
    isFormValid: false,
    calculationsMethod: undefined,
    filterMethod: undefined,
    timeInterval: [],
    averageData: false,
  }),
  computed: {
    isStickyButtonsLoading: sync('sidebar/isStickyButtonsLoading'),
    isStickyButtonsValid: sync('sidebar/isStickyButtonsValid'),
    isStickyButtonsVisible: sync('sidebar/isStickyButtonsVisible'),
    stickyButtons: sync('sidebar/stickyButtons'),
  },
  watch: {
    isFormValid: {
      immediate: true,
      handler(nV) {
        this.isStickyButtonsValid = nV;
      },
    },
  },
  methods: {
    exportCalibrationFile: call('epanet/getCalibrationFile'),
    async generateCalibrationFile() {
      this.isStickyButtonsLoading = true;
      const payload = {
        average_to_model_duration: this.averageData,
        data_calculation: this.calculationsMethod,
        no_data: this.filterMethod,
        since: this.timeInterval[0],
        until: this.timeInterval.length > 1 ? this.timeInterval[1] : this.timeInterval[0],
      };
      try {
        return await this.exportCalibrationFile(payload);
      } finally {
        this.isStickyButtonsLoading = false;
      }
    },
  },
  mounted() {
    this.$root.$off('generateCalibrationFile');
    this.$root.$on('generateCalibrationFile', this.generateCalibrationFile);
    this.stickyButtons = [
      {
        action: 'generateCalibrationFile',
        translationPath: 'sidebar.calibrationFilesGeneration.download',
      },
    ];
    this.isStickyButtonsValid = false;
    this.isStickyButtonsLoading = false;
    this.isStickyButtonsVisible = true;
  },
};
</script>

<style lang="scss" scoped>
.label-dark {
  color: #202124;
}
.center-content {
  display: flex;
  align-items: center;
}
::v-deep {
  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
